import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import font from "src/styles/font";
import { checkNotEmpty } from "src/common";

import {
  TextField,
  Grid,
  Autocomplete,
  createFilterOptions,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
  Box,
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import Tooltip from "src/components/upload/Tooltip";
import { MainSwitch as Switch } from "src/components/core/Switch";

import { UseUpload } from "src/context/UploadProductContext";

import UnitPriceGrid from "./UnitPriceGrid";

const SpanTitle = styled.div`
  font-size: ${font.size.lg};
  color: var(--secondary-color);
  font-weight: 400;

  span {
    font-size: ${font.size.lg};
    font-weight: 400;
    color: var(--primary-color);
  }

  ${({ subTitle }) =>
    subTitle &&
    css`
      margin-bottom: 16px;
    `}
`;

const SpanLabel = styled.div`
  font-size: ${font.size.md};
  color: var(--secondary-color);
  font-weight: 400;

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--primary-color);
  }

  ${({ subTitle }) =>
    subTitle &&
    css`
      margin-bottom: 16px;
    `}
`;

const WrapperTextfield = styled.div`
  /* width: ${({ half }) => (half ? "48.5%" : "100%")}; */
  width: 100%;

  ${({ divTool }) =>
    divTool &&
    css`
      display: flex;
      gap: 10px;
    `}

  ${({ textEditor }) =>
    textEditor &&
    css`
      margin-top: 16px;
    `}

  ${({ divPrice }) =>
    divPrice &&
    css`
      display: flex;
      gap: 6px;
      margin-top: 24px;
    `}

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 24px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0;
  }
`;

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: max-content;
`;

const WrapperFormLabel = styled.div`
  min-height: 56px;
  display: flex;
  align-items: center;
  /* margin: auto 0; */
`;

const ChoiceProduct = ({ choiceIndex }) => {
  const {
    dataUploadChoice,
    masterdata,
    onChangeUpload,
    onRemoveChoice,
    choiceErrors,
    initialConfirm,
    setConfirmInfo,
  } = UseUpload();

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

  const sortHashtag = masterdata.hashtag_data.sort((a, b) => {
    return b.product_count - a.product_count;
  });

  return (
    <>
      <Grid
        container
        rowSpacing={3}
        sx={{
          m: 0,
          // mt: 5,
          p: 5,
          width: "100%",
          borderRadius: "24px",
          background: "var(--white-color)",
          boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
          "&>.MuiGrid-item:first-child": {
            pt: 0,
          },
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <SpanTitle>ตัวเลือกสินค้าที่ {choiceIndex + 1}/10</SpanTitle>

          <IconButton
            aria-label="delete"
            onClick={() => onRemoveChoice(choiceIndex)}
            sx={{
              width: "32px",
              height: "32px",
              backgroundColor: "var(--darkwhite-color)",
              color: "var(--secondary-color)",
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Grid>

        {/* Product Detail */}
        <Grid item xs={12}>
          <SpanLabel>
            รายละเอียดสินค้า<span>*</span>
          </SpanLabel>

          <Grid
            container
            spacing={0}
            rowSpacing={0}
            columnSpacing={3}
            sx={{
              mt: 0,
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            {/* left */}
            <Grid item xs={6}>
              <Grid
                container
                spacing={0}
                rowSpacing={3}
                columnSpacing={0}
                sx={{
                  m: 0,
                  ".MuiFormHelperText-root": {
                    position: "absolute",
                    bottom: "-20px",
                  },
                }}
              >
                <Grid item xs={12}>
                  <WrapperTextfield className="form-input" divTool>
                    <TextField
                      label={`ชื่อตัวเลือกสินค้าที่ ${choiceIndex + 1}`}
                      variant="outlined"
                      fullWidth
                      value={dataUploadChoice[choiceIndex]?.name}
                      onChange={(e) =>
                        onChangeUpload(e, `choices.${choiceIndex}.name`)
                      }
                      error={!!choiceErrors[`choices[${choiceIndex}].name`]}
                      helperText={
                        !!choiceErrors[`choices[${choiceIndex}].name`]
                          ? "โปรดระบุชื่อสินค้า"
                          : ""
                      }
                    />
                    <Tooltip
                      title={
                        "โปรดใส่ชื่อตัวเลือกสินค้า เช่น สีขาว a1000 หรือ สีโอ๊คไวท์"
                      }
                    />
                  </WrapperTextfield>
                </Grid>

                <Grid item xs={12}>
                  <WrapperTextfield className="form-input" divTool>
                    <Autocomplete
                      id="select-pattern"
                      isOptionEqualToValue={(option, value) =>
                        option?._id === value?._id
                      }
                      options={masterdata.pattern_data}
                      value={dataUploadChoice[choiceIndex]?.pattern}
                      onChange={(e, newValue) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.pattern`,
                          newValue,
                        );
                      }}
                      getOptionLabel={(option) => {
                        return getLocale() === "th"
                          ? option.pattern_th
                          : option.pattern_en;
                      }}
                      disablePortal
                      blurOnSelect
                      sx={{
                        my: 2,
                        width: "100%",
                        background: "#fff",
                        ".MuiOutlinedInput-root": {
                          paddingLeft: "16px",
                        },
                        ".MuiAutocomplete-option": {
                          p: 3,
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="TextField-without-border-radius"
                          {...params}
                          label="ลวดลาย"
                          error={
                            !!choiceErrors[`choices[${choiceIndex}].pattern`]
                          }
                          helperText={
                            !!choiceErrors[`choices[${choiceIndex}].pattern`]
                              ? "โปรดเลือกลวดลาย"
                              : ""
                          }
                        />
                      )}
                    />
                    <Tooltip
                      title={
                        "โปรดระบุ ลวดลายที่ตรง หรือใกล้เคียงกับสินค้าของคุณ"
                      }
                    />
                  </WrapperTextfield>
                </Grid>
              </Grid>
            </Grid>

            {/* right */}
            <Grid item xs={6}>
              <Grid
                container
                spacing={0}
                rowSpacing={3}
                columnSpacing={0}
                sx={{
                  m: 0,
                  ".MuiFormHelperText-root": {
                    position: "absolute",
                    bottom: "-20px",
                  },
                }}
              >
                <Grid item xs={12}>
                  <WrapperTextfield className="form-input" divTool>
                    <Autocomplete
                      id="select-color"
                      isOptionEqualToValue={(option, value) =>
                        option?._id === value?._id
                      }
                      options={masterdata.color_data}
                      value={dataUploadChoice[choiceIndex]?.color}
                      onChange={(event, newValue) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.color`,
                          newValue,
                        );
                      }}
                      getOptionLabel={(option) => {
                        return getLocale() === "th"
                          ? option.color_th
                          : option.color_en;
                      }}
                      disablePortal
                      blurOnSelect
                      sx={{
                        my: 2,
                        width: "100%",
                        background: "#fff",
                        ".MuiOutlinedInput-root": {
                          paddingLeft: "16px",
                        },
                        ".MuiAutocomplete-option": {
                          p: 3,
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="TextField-without-border-radius"
                          {...params}
                          label="สี"
                          error={
                            !!choiceErrors[`choices[${choiceIndex}].color`]
                          }
                          helperText={
                            !!choiceErrors[`choices[${choiceIndex}].color`]
                              ? "โปรดเลือกสี"
                              : ""
                          }
                        />
                      )}
                    />
                    <Tooltip
                      title={
                        "โปรดระบุสีที่ตรงกับสินค้า หรือใกล้เคียงกับสินค้าของคุณ"
                      }
                    />
                  </WrapperTextfield>
                </Grid>

                <Grid item xs={12}>
                  <WrapperTextfield className="form-input" divTool>
                    <Autocomplete
                      id="select-texture"
                      isOptionEqualToValue={(option, value) =>
                        option?._id === value?._id
                      }
                      options={masterdata.textureType_data}
                      value={dataUploadChoice[choiceIndex].texture_type}
                      onChange={(event, newValue) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.texture_type`,
                          newValue,
                        );
                      }}
                      getOptionLabel={(option) => {
                        return getLocale() === "th"
                          ? option.type_th
                          : option.type_en;
                      }}
                      disablePortal
                      blurOnSelect
                      sx={{
                        my: 2,
                        width: "100%",
                        background: "#fff",
                        ".MuiOutlinedInput-root": {
                          paddingLeft: "16px",
                        },
                        ".MuiAutocomplete-option": {
                          p: 3,
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="TextField-without-border-radius"
                          {...params}
                          label="ผิวสัมผัส"
                          error={
                            !!choiceErrors[
                              `choices[${choiceIndex}].texture_type`
                            ]
                          }
                          helperText={
                            !!choiceErrors[
                              `choices[${choiceIndex}].texture_type`
                            ]
                              ? "โปรดเลือกผิวสัมผัส"
                              : ""
                          }
                        />
                      )}
                    />
                    <Tooltip
                      title={
                        "โปรดระบุผิวสัมผัสที่ตรงกับสินค้า หรือใกล้เคียงกับสินค้าของคุณ"
                      }
                    />
                  </WrapperTextfield>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Sales Detail */}
        <Grid item xs={12}>
          <SpanLabel>
            รายละเอียดการขาย<span>*</span>
          </SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={3}
            sx={{
              mt: 0,
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            <Grid item xs={6} sx={{ alignSelf: "center" }}>
              <WrapperFormLabel>
                <FormControlLabel
                  label="สินค้าพรีออเดอร์"
                  sx={{
                    margin: 0,
                    ".MuiFormControlLabel-label": {
                      fontSize: "1rem",
                    },
                    ".MuiCheckbox-root": {
                      p: 0,
                      pr: 1,
                    },
                  }}
                  control={
                    <Checkbox
                      name="install-price-checkbox"
                      sx={{
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                        ".MuiSvgIcon-root": {
                          fontSize: "1.5rem",
                        },
                      }}
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<RadioButtonCheckedIcon />}
                      checked={
                        checkNotEmpty(
                          dataUploadChoice[choiceIndex].pre_order_date,
                        )
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        if (
                          checkNotEmpty(
                            dataUploadChoice[choiceIndex].pre_order_date,
                          )
                        ) {
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.pre_order_date`,
                            null,
                          );
                        } else {
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.pre_order_date`,
                            "7 - 14  วัน",
                          );
                        }
                      }}
                    />
                  }
                />
              </WrapperFormLabel>
            </Grid>

            {checkNotEmpty(dataUploadChoice[choiceIndex].pre_order_date) ? (
              <Grid item xs={3} sx={{ minHeight: 80 }}>
                <WrapperTextfield className="form-input">
                  <FormControl
                    fullWidth
                    error={
                      !!choiceErrors[`choices[${choiceIndex}].pre_order_date`]
                    }
                  >
                    <InputLabel id="preorder-date-label">
                      จำนวนวันที่พร้อมส่ง
                    </InputLabel>
                    <Select
                      labelId="preorder-date-label"
                      id="preorder-date"
                      displayEmpty
                      defaultValue={"7 - 14  วัน"}
                      value={dataUploadChoice[choiceIndex].pre_order_date}
                      label="จำนวนวันที่พร้อมส่ง"
                      onChange={(e) =>
                        onChangeUpload(
                          e,
                          `choices.${choiceIndex}.pre_order_date`,
                        )
                      }
                    >
                      <MenuItem value={`7 - 14  วัน`}>7 - 14 วัน</MenuItem>
                      <MenuItem value={`15 - 30 วัน`}>15 - 30 วัน</MenuItem>
                      <MenuItem value={`35 - 60 วัน`}>35 - 60 วัน</MenuItem>
                    </Select>
                    {!!choiceErrors[
                      `choice[${choiceIndex}].pre_order_date`
                    ] && (
                      <FormHelperText sx={{ width: "max-content" }}>
                        Please select pre-order date
                      </FormHelperText>
                    )}
                  </FormControl>
                </WrapperTextfield>
              </Grid>
            ) : (
              <Grid item xs={3} sx={{ minHeight: 80 }}></Grid>
            )}

            <Grid item xs={6} sx={{ alignSelf: "center" }}>
              <WrapperFormLabel>
                <FormControlLabel
                  label="สินค้ามีสต็อก"
                  sx={{
                    margin: 0,
                    ".MuiFormControlLabel-label": {
                      fontSize: "1rem",
                    },
                    ".MuiCheckbox-root": {
                      p: 0,
                      pr: 1,
                    },
                  }}
                  control={
                    <Checkbox
                      name="instock-checkbox"
                      sx={{
                        "&.Mui-checked": {
                          color: "#e04132",
                        },
                        ".MuiSvgIcon-root": {
                          fontSize: "1.5rem",
                        },
                      }}
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<RadioButtonCheckedIcon />}
                      checked={dataUploadChoice[choiceIndex].is_instock}
                      onChange={(e) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.is_instock`,
                          e.target.checked,
                        );

                        if (
                          checkNotEmpty(
                            dataUploadChoice[choiceIndex].is_instock,
                          )
                        ) {
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.stock_count`,
                            null,
                          );
                        } else {
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.stock_count`,
                            0,
                          );
                        }
                      }}
                    />
                  }
                />
              </WrapperFormLabel>
            </Grid>

            {dataUploadChoice[choiceIndex].is_instock ? (
              <Grid item xs={3} sx={{ minHeight: 80 }}>
                <WrapperTextfield className="form-input">
                  <TextField
                    label="จำนวนสต็อกสินค้า"
                    variant="outlined"
                    fullWidth
                    value={dataUploadChoice[choiceIndex]?.stock_count || ""}
                    onChange={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.stock_count`,
                          e.target.value,
                        );
                    }}
                    onBlur={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.stock_count`,
                          parseFloat(e.target.value) || null,
                        );
                    }}
                    error={
                      !!choiceErrors[`choices[${choiceIndex}].stock_count`]
                    }
                    // helperText={
                    //   !!choiceErrors[`choices[${choiceIndex}].pre_order_date`]
                    //     ? "โปรดระบุจจำนวนสต็อกสินค้า"
                    //     : ""
                    // }
                    FormHelperTextProps={{
                      style: { minHeight: "20px" },
                    }}
                  />
                </WrapperTextfield>
              </Grid>
            ) : null}

            {/* Unit Price */}
            <Grid item xs={12}>
              <UnitPriceGrid choiceIndex={choiceIndex} />
            </Grid>
          </Grid>
        </Grid>

        {/* Sample detail / Hashtags */}
        <Grid item xs={12}>
          <SpanLabel>สินค้าตัวอย่าง</SpanLabel>
          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={3}
            sx={{
              mt: 0,
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            <Grid item xs={6}>
              <WrapperButton>
                <FormControlLabel
                  label="สินค้าสามารถขอแผ่นตัวอย่างได้"
                  sx={{
                    ".MuiFormControlLabel-label": {
                      ml: 1,
                      fontSize: font.size.md,
                    },
                  }}
                  control={
                    <Switch
                      sx={{ m: 1 }}
                      checked={dataUploadChoice[choiceIndex]?.is_sample}
                      onChange={(e) => {
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.is_sample`,
                          e.target.checked,
                        );
                      }}
                    />
                  }
                />
              </WrapperButton>

              {dataUploadChoice[choiceIndex]?.is_sample && (
                <WrapperTextfield
                  className={
                    dataUploadChoice[choiceIndex].group_price.sample_price !==
                    null
                      ? "form-input"
                      : ""
                  }
                  divPrice
                >
                  <TextField
                    label="ราคาสินค้าตัวอย่าง"
                    variant="outlined"
                    sx={{
                      width: "50%",
                      borderRadius: "16px",
                    }}
                    value={
                      dataUploadChoice[choiceIndex].group_price.sample_price ??
                      ""
                    }
                    onChange={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.sample_price`,
                          e.target.value,
                        );
                    }}
                    onBlur={(e) => {
                      if (e.target.value * 0 === 0)
                        onChangeUpload(
                          null,
                          `choices.${choiceIndex}.group_price.sample_price`,
                          parseFloat(e.target.value) || null,
                        );
                    }}
                    error={
                      !!choiceErrors[
                        `choices[${choiceIndex}].group_price.sample_price`
                      ]
                    }
                    helperText={
                      !!choiceErrors[
                        `choices[${choiceIndex}].group_price.sample_price`
                      ]
                        ? "Please enter Sample price"
                        : ""
                    }
                    disabled={
                      dataUploadChoice[choiceIndex]?.group_price
                        ?.sample_price === null &&
                      !choiceErrors[
                        `choices[${choiceIndex}].group_price.sample_price`
                      ]
                    }
                  />

                  <FormControlLabel
                    label="ขอสินค้าตัวอย่างฟรี"
                    sx={{
                      width: "50%",
                      maxHeight: "72px",
                      margin: 0,
                    }}
                    control={
                      <Checkbox
                        name="sample-price-checkbox"
                        sx={{
                          "&.Mui-checked": {
                            color: "#e04132",
                          },
                        }}
                        checked={
                          dataUploadChoice[choiceIndex]?.group_price
                            ?.sample_price === null
                        }
                        onChange={(e) => {
                          onChangeUpload(
                            null,
                            `choices.${choiceIndex}.group_price.sample_price.is_free`,
                            e.target.checked,
                          );
                        }}
                      />
                    }
                  />
                </WrapperTextfield>
              )}
            </Grid>

            <Grid item xs={12}>
              <WrapperTextfield className="form-input" divTool>
                <Autocomplete
                  id="combo-box-hashtag"
                  fullWidth
                  multiple
                  // options={masterdata?.hashtag_data?.map((tags) => ({ name: tags.name }))}
                  options={sortHashtag}
                  getOptionLabel={(option) => {
                    return `#${option.name}`;
                  }}
                  value={dataUploadChoice[choiceIndex]?.hashtags}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value.name
                  }
                  onChange={(e, value) => {
                    if (
                      dataUploadChoice[choiceIndex]?.hashtags.length > 1 &&
                      value.length === 0
                    ) {
                      setConfirmInfo((info) => ({
                        ...info,
                        visible: true,
                        title:
                          getLocale() === "th"
                            ? `คุณต้องการลบแฮชแท็กทั้งหมดใช่หรือไม่`
                            : `คุณต้องการลบแฮชแท็กทั้งหมดใช่หรือไม่`,
                        confirmFunc: () => {
                          onChangeUpload(
                            e,
                            `choices.${choiceIndex}.hashtags`,
                            value,
                          );
                          setConfirmInfo(initialConfirm);
                        },
                      }));
                    } else {
                      onChangeUpload(
                        e,
                        `choices.${choiceIndex}.hashtags`,
                        value,
                      );
                    }
                  }}
                  freeSolo
                  disableCloseOnSelect
                  ListboxComponent={forwardRef(
                    ({ children, index, ...props }, ref) => (
                      <ul
                        {...props}
                        ref={ref}
                        key={`list-${index}`}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          flexWrap: "wrap",
                        }}
                      >
                        {children}
                      </ul>
                    ),
                  )}
                  renderOption={(props, option, { selected }, index) => (
                    <>
                      {option?.empty ? (
                        <li
                          {...props}
                          key={`hashtag-option-${index}`}
                          style={{
                            maxWidth: "100%",
                            color: "var(--darkgrey-color)",
                          }}
                        >
                          {option?.empty}
                        </li>
                      ) : (
                        <li
                          {...props}
                          key={`hashtag-option-${index}`}
                          style={{
                            flex: "0 0 25%",
                            maxWidth: "25%",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              sx={{
                                "&.Mui-checked": {
                                  color: "#E13B30",
                                },
                              }}
                              checked={selected || false}
                            />
                            {option.name}
                          </div>
                          <p
                            style={{
                              width: "100%",
                              margin: 0,
                              fontSize: "0.75rem",
                              color: "#6C6C70",
                              paddingLeft: "40px",
                            }}
                          >
                            ถูกใช้ไปแล้ว {option.product_count} ครั้ง
                          </p>
                        </li>
                      )}
                    </>
                  )}
                  noOptionsText="Press ENTER to add hashtag"
                  filterOptions={(options, params) => {
                    const filtered = filterOptions(options, params);

                    if (filtered.length === 0 && params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        empty: `Press ENTER to add new hashtag`,
                      });
                    }

                    return filtered;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="#Hashtag"
                      error={!!choiceErrors[`choices[0].hashtags`]}
                      helperText={
                        !!choiceErrors[`choices[0].hashtags`] ? (
                          "กรุณาเลือกแฮชแท็ก"
                        ) : (
                          <Box sx={{ height: "20px" }} />
                        )
                      }
                    />
                  )}
                />
                <Tooltip
                  title={
                    "การใส่แฮชแท็กจะช่วยให้ลูกค้าค้นหาสินค้าของคุณเจอได้ง่ายยิ่งขึ้น"
                  }
                />
              </WrapperTextfield>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ChoiceProduct;
